// @ts-expect-error Could not find a declaration file for module
import dragula from 'dragula';
import './oip-module-select.scss'
import '@/components/oip-module-item/oip-module-item'
import {SbkButton} from "@/components/button/button.ts";

//------------------------------------*\
// #Component
//------------------------------------*/

const OipModuleSelect = {
  ids: {
    formModules: 'modulesData',
  },
    cssClasses: {
        allServices: 'services--all',
        topServices: 'services--top',
        additionalServices: 'services--additional',
        dragContainer: 'draggable__container',
        empty: 'is-empty',
        filled: 'is-filled',
        tile: 'service__tile',
        infoButton: 'tile__button--info',
        deleteButton: 'tile__button--remove',
        formNavigation: 'form_nav-buttons',
        previewButton: 'btn--preview',
    },
    initialize: () => {

        const containers: Element[] = Array.from(document.querySelectorAll(`.${OipModuleSelect.cssClasses.dragContainer}`));
        const serviceTiles: HTMLElement[] = Array.from(document.querySelectorAll(`.${OipModuleSelect.cssClasses.tile}`));
        const searchInput: HTMLInputElement|null =  document.querySelector('#serviceSearch');
        const serviceAreaFilter: HTMLSelectElement|null = document.querySelector('#serviceAreaFilter');
        const submitButtons: SbkButton[] = Array.from(document.querySelectorAll(`.${OipModuleSelect.cssClasses.formNavigation} sbk-button[type="submit"]`));
        const formModules: HTMLFormElement|null = document.querySelector(`form#${OipModuleSelect.ids.formModules}`);

        (submitButtons && formModules) && OipModuleSelect.initializeSubmitButtons(submitButtons, formModules);
        containers && OipModuleSelect.initializeServices(containers, submitButtons);
        serviceTiles && OipModuleSelect.initializeServiceTiles(serviceTiles, submitButtons);
        (searchInput && serviceAreaFilter) && OipModuleSelect.initializeFilters(searchInput, serviceAreaFilter);
    },
    initializeSubmitButtons: (submitButtons: SbkButton[], form: HTMLFormElement) => {

        submitButtons.forEach(submitButton =>{
            if (submitButton.classList.contains(OipModuleSelect.cssClasses.previewButton)) {
                submitButton.addEventListener('sbk-click', (e) => {
                    e.preventDefault();
                    form.target = '_blank'
                    form?.requestSubmit(submitButton.fakeSubmitButton)
                });
            } else {
                submitButton.addEventListener('sbk-click', (e) => {
                    e.preventDefault();
                    form.target = ''
                    form?.requestSubmit(submitButton.fakeSubmitButton)
                });
            }
        });
    },
    initializeServices: (containers: Element[], submitButtons: SbkButton[]) => {
        const topServicesContainer = document.querySelector(`.${OipModuleSelect.cssClasses.topServices} .${OipModuleSelect.cssClasses.dragContainer}`);
        const additionalServicesContainer = document.querySelector(`.${OipModuleSelect.cssClasses.additionalServices} .${OipModuleSelect.cssClasses.dragContainer}`);
        if((topServicesContainer && topServicesContainer.children.length <= 1) ||
        (additionalServicesContainer && additionalServicesContainer.children.length <= 1)) {
            OipModuleSelect.disableSubmitButton(submitButtons);
        }

        const drake = dragula(containers, {
            revertOnSpill: true,
            accepts: (_: HTMLElement, target: HTMLElement, source: HTMLElement): boolean => {
                const isAllServicesTarget: boolean = target.parentElement?.classList.contains(OipModuleSelect.cssClasses.allServices) ?? false;
                const isTopServicesTarget: boolean = target.parentElement?.classList.contains(OipModuleSelect.cssClasses.topServices) ?? false;
                const isAdditionalServicesTarget: boolean = target.parentElement?.classList.contains(OipModuleSelect.cssClasses.additionalServices) ?? false;

                const isTopServicesSource: boolean = source.parentElement?.classList.contains(OipModuleSelect.cssClasses.topServices) ?? false;
                const isAdditionalServicesSource: boolean = source.parentElement?.classList.contains(OipModuleSelect.cssClasses.additionalServices) ?? false;
                
                if(isAllServicesTarget) return false;

                if(isTopServicesSource || isAdditionalServicesSource) {
                    if(target.children.length < 2) {
                        source.classList.add(OipModuleSelect.cssClasses.empty);
                    }
                }

                // Don't accept element when there are already 3 elements in container
                if(isTopServicesTarget) {
                    if(target.children.length > 4) {
                        return false;
                    }
                }

                // Don't accept element when there are already 5 elements in container
                if(isAdditionalServicesTarget) {
                    if(target.children.length> 6) {
                        return false;
                    }
                }

                return true; // elements can be dropped in any of the `containers` by default
            }
        });

        drake.on('drag', (_: HTMLElement, source: HTMLElement) => {
            const isTopServices = source.parentElement?.classList.contains(OipModuleSelect.cssClasses.topServices);
            const isAdditionalServices = source.parentElement?.classList.contains(OipModuleSelect.cssClasses.additionalServices);

            if (isTopServices && source.children.length === 4) {
                source.classList.remove(OipModuleSelect.cssClasses.filled);
                OipModuleSelect.disableSubmitButton(submitButtons);
            }
            if (isAdditionalServices && source.children.length === 3) {
                source.classList.remove(OipModuleSelect.cssClasses.filled);
                OipModuleSelect.disableSubmitButton(submitButtons);
            }
        });

        drake.on('drop', (el: HTMLElement, container: HTMLElement, source: HTMLElement) => {
            const isTopServices = container.parentElement?.classList.contains(OipModuleSelect.cssClasses.topServices);
            const isAdditionalServices = container.parentElement?.classList.contains(OipModuleSelect.cssClasses.additionalServices);
            const isAllServicesSource = source.parentElement?.classList.contains(OipModuleSelect.cssClasses.allServices);
            const topServicesContainer = document.querySelector(`.${OipModuleSelect.cssClasses.topServices} .${OipModuleSelect.cssClasses.dragContainer}`);
            const additionalServicesContainer = document.querySelector(`.${OipModuleSelect.cssClasses.additionalServices} .${OipModuleSelect.cssClasses.dragContainer}`);

            const addHiddenInput = (name: string, value: string) => {
                const selectedServiceInput: HTMLInputElement = document.createElement("input");
                selectedServiceInput.setAttribute("type", "hidden");
                selectedServiceInput.setAttribute("id", `associatedService${value}`);
                selectedServiceInput.setAttribute("name", `tx_mmsoip_configurator[modulesData][${name}][]`);
                selectedServiceInput.setAttribute("value", value);
                el.appendChild(selectedServiceInput);
            };

            const removeHiddenInput = (id: string) => {
                const input = document.getElementById(`associatedService${id}`);
                input && el.removeChild(input);
            };

            const inputName = isTopServices ? "topModules" : "additionalModules";
            (!isAllServicesSource) && removeHiddenInput(el.dataset.id ?? '');
            (isTopServices || isAdditionalServices) && addHiddenInput(inputName , el.dataset.id  ?? '');

            if (isTopServices && container.children.length > 1) {
                container.classList.remove(OipModuleSelect.cssClasses.empty);
                OipModuleSelect.disableSubmitButton(submitButtons);
            }

            (isTopServices && container.children.length === 4) &&
                container.classList.add(OipModuleSelect.cssClasses.filled);

            if (isAdditionalServices && container.children.length > 1) {
                container.classList.remove(OipModuleSelect.cssClasses.empty);
                OipModuleSelect.disableSubmitButton(submitButtons);
            }

            (isAdditionalServices && container.children.length === 6) &&
                container.classList.add(OipModuleSelect.cssClasses.filled);

            if(topServicesContainer && additionalServicesContainer && topServicesContainer.children.length === 4 && additionalServicesContainer.children.length >= 3){
                OipModuleSelect.enableSubmitButton(submitButtons);
            }
        });

        /**
         * Sets initial state and adds event listeners
         */

        // IIFE called when script is loaded
        // Immediately invoked function expression
        (function initModule() {
            // Event listeners
        })();
    },
    initializeServiceTiles: (tiles: HTMLElement[], submitButtons: SbkButton[]) => {

        const allServicesContainer = document.querySelector(`.${OipModuleSelect.cssClasses.allServices} .${OipModuleSelect.cssClasses.dragContainer}`);
        const topServicesContainer = document.querySelector(`.${OipModuleSelect.cssClasses.topServices} .${OipModuleSelect.cssClasses.dragContainer}`);
        const additionalServicesContainer = document.querySelector(`.${OipModuleSelect.cssClasses.additionalServices} .${OipModuleSelect.cssClasses.dragContainer}`);

        if (!allServicesContainer || !topServicesContainer || !additionalServicesContainer) {
            return;
        }

        const sortAllServicesContainer = () => {
            const allServicesContainerChildren: HTMLElement[] = Array.from(allServicesContainer.querySelectorAll(`.${OipModuleSelect.cssClasses.tile}`));

            allServicesContainerChildren.sort(
                (a: HTMLElement, b: HTMLElement) => {
                    const aId = parseInt(a.dataset.id ?? '');
                    const bId = parseInt(b.dataset.id ?? '');
                    return aId - bId;
                }
            ).forEach(
                (item) => item.parentElement?.appendChild(item)
            )
        };

        tiles.forEach(tile => {
            const deleteButton = tile.querySelector('sbk-round-button[icon="trash"]');

            const removeInputsFromTile = (tile: Element) => {
                const inputs = Array.from(tile.querySelectorAll('input'));
                inputs.forEach(function(input: HTMLInputElement) {
                    tile.removeChild(input);
                });
                return tile;
            };
            const tempTile = tile;

            deleteButton && deleteButton.addEventListener('click', () => {
                tile.remove();
                allServicesContainer.append(tempTile);
                removeInputsFromTile(tempTile);
                
                topServicesContainer.children.length < 4 && OipModuleSelect.disableSubmitButton(submitButtons);
                topServicesContainer.children.length <= 1 && topServicesContainer.classList.add(OipModuleSelect.cssClasses.empty);
                additionalServicesContainer.children.length < 3 && OipModuleSelect.disableSubmitButton(submitButtons);
                additionalServicesContainer.children.length <= 1 && additionalServicesContainer.classList.add(OipModuleSelect.cssClasses.empty);

                sortAllServicesContainer();
            })
        })
    },
    initializeFilters: (searchInput: HTMLInputElement, serviceAreaFilter: HTMLSelectElement) => {

      let searchInputValue = '';
        let serviceAreaFilterValue = '';

        const allServicesContainer = document.querySelector(`.${OipModuleSelect.cssClasses.allServices} .${OipModuleSelect.cssClasses.dragContainer}`);

        const hideTile = (tile: HTMLElement) => {
            tile.hidden = true;
        };

        const showTile = (tile: HTMLElement) => {
            tile.hidden = false;
        };

        const filterServices = (searchValue: string, selectedServiceArea: string) => {
            if (!allServicesContainer) {
                return;
            }
            const allServicesContainerChildren: HTMLElement[] = Array.from(allServicesContainer.querySelectorAll(`.${OipModuleSelect.cssClasses.tile}`));
            allServicesContainerChildren.forEach(tile => {
                const serviceAreas = tile.dataset.serviceArea?.split(',') ?? [];

                OipModuleSelect.matchesSearchString(tile.getAttribute('headline') ?? '', searchValue)
                    &&  OipModuleSelect.matchesModuleArea(serviceAreas, selectedServiceArea)
                    ? showTile(tile)
                    : hideTile(tile);
            });
        };
        searchInput.addEventListener('input-input', ((e: CustomEvent) => {
            searchInputValue = e.detail.value;
            filterServices(searchInputValue, serviceAreaFilterValue);
        }) as EventListener);
        serviceAreaFilter.addEventListener('select-value-changed', ((e: CustomEvent) => {
            serviceAreaFilterValue = e.detail.value;
            filterServices(searchInputValue, serviceAreaFilterValue);
        }) as EventListener);
    },
    matchesModuleArea: (value: string[], searchValue: string) => {
        if (!searchValue || searchValue === "all") {
            return true;
        }
        return value.includes(searchValue);
    },
    matchesSearchString: (value: string, searchValue: string) => {
      if (!searchValue) {
          return true;
      }
      return value.toLowerCase().includes(searchValue.toLowerCase());
    },
    disableSubmitButton: (submitButtons: SbkButton[]) => {
        submitButtons.forEach(submitButton => {
            submitButton.disabled = true;
            submitButton.closest('.btn')?.classList.add('btn--disabled');
        })
    },
    enableSubmitButton: (submitButtons: SbkButton[]) => {
        submitButtons.forEach(submitButton => {
            submitButton.disabled = false;
            submitButton.closest('.btn')?.classList.remove('btn--disabled');
        });
    },
};

OipModuleSelect.initialize();
